<template>
  <div class="testimonios-carousel">
    <div 
      class="testimonios-wrapper"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <transition name="fade" mode="out-in">
        <div 
          :key="currentIndex" 
          class="card-equipo"
        >
          <p class="p-16 pb-5 testimony-text">
            "{{ currentTestimony.testimony }}"
          </p>
          <p class="p-16 italic bold testimony-author">
            - {{ currentTestimony.name }}, {{ currentTestimony.position }}
          </p>
        </div>
      </transition>
    </div>
    
    <!-- Controles de navegación -->
    <button 
      class="testimonios-btn testimonios-btn-prev d-none d-lg-block" 
      @click="prevSlide"
      aria-label="Testimonio anterior"
      v-if="testimonios.length > 1"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <button 
      class="testimonios-btn testimonios-btn-next d-none d-lg-block" 
      @click="nextSlide"
      aria-label="Testimonio siguiente"
      v-if="testimonios.length > 1"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <!-- Indicadores -->
    <div class="testimonios-indicators" v-if="testimonios.length > 1">
      <button
        v-for="(testimony, index) in testimonios"
        :key="index"
        @click="goToSlide(index)"
        :class="['indicator', { active: currentIndex === index }]"
        :aria-label="`Ir a testimonio ${index + 1}`"
      ></button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CarouselTestimonios',
  data() {
    return {
      currentIndex: 0,
      autoPlayInterval: null,
      touchStartX: 0,
      touchEndX: 0,
      minSwipeDistance: 50
    }
  },
  computed: {
    ...mapGetters(['getTestimonios']),
    testimonios() {
      return this.getTestimonios
    },
    currentTestimony() {
      return this.testimonios[this.currentIndex] || {}
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeUnmount() {
    this.stopAutoPlay()
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.testimonios.length
    },
    prevSlide() {
      this.currentIndex = this.currentIndex === 0 
        ? this.testimonios.length - 1 
        : this.currentIndex - 1
    },
    goToSlide(index) {
      this.currentIndex = index
      this.resetAutoPlay()
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide()
      }, 8000) // Cambia cada 8 segundos (más tiempo para leer)
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval)
        this.autoPlayInterval = null
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
    },
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX
    },
    handleTouchEnd() {
      const swipeDistance = this.touchStartX - this.touchEndX
      
      // Swipe hacia la izquierda (siguiente)
      if (swipeDistance > this.minSwipeDistance) {
        this.nextSlide()
        this.resetAutoPlay()
      }
      
      // Swipe hacia la derecha (anterior)
      if (swipeDistance < -this.minSwipeDistance) {
        this.prevSlide()
        this.resetAutoPlay()
      }
      
      // Reset
      this.touchStartX = 0
      this.touchEndX = 0
    }
  }
}
</script>

